import logo_footer from 'assets/icons/Home/logo_footer.png';

function LegalFooter() {
   return (
      <div className = "HomeFtLegal">
         <img src = { logo_footer } alt = "logo_footer" />
      </div>
   )
}
export default LegalFooter